/** @format */

import React, { useState, useEffect } from "react";
import Icon, {InfoCircleOutlined} from "@ant-design/icons";
import { Radio, Input, Button, message,Tooltip } from "antd";
import closeButton from "../../public/filestore/closeButton";
import Link from "next/link";
import addToCollectionIcon from "../../public/filestore/addToCollection";
import { logger } from "@goldenbird1/ui-logger-library";
import { useRouter } from "next/router";
// import { addToCollectionEvent } from "../../utils/moEngageEvents";
import { add_collection } from "../../utils/GTMDataLayer";
import { getConvertedCurrency } from "../../utils/currencyConverter";
import { v4 as uuidv4 } from "uuid";


function AddToCollection(props) {
  let {
    contentData = [],
    onClose = "",
    token = "",
    userProfile = {},
    articleId = "",
    sellerCode = "",
    savedProductToCollection = "",
    refreshCollection = "",
    setAnimationLoader = "",
    onCheck,
    color,
    size,
    skuId,
    variantId,
    standardSize,
    newSkuId,
    sizes,
    colors,
    selProductId
  } = props;
  
  const router = useRouter();
  const [value, setValue] = useState(props.selectedCollection);
  const [error, setError] = useState(false);
  const [charError, setCharError] = useState(false)
  const [collections, setCollections] = useState([]);
  const [collectionName, setCollectionName] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);
  let { profileId = "" } = userProfile || {};

  useEffect(() => {
    let { userCollections = "" } = props;
    if (userCollections && userCollections.length) {
      setCollections(props.userCollections);
      if (props.selectedCollection) {
        setValue(props.selectedCollection);
      } else {
        setValue(props.userCollections[0]["name"]);
      }
    }
    else{
      setCollections([{name:`${userProfile.firstName}_collection`}])
      setValue(`${userProfile.firstName}_collection`)
    }
  }, [props.userCollections]);

  const onChange = (e) => {
    let newCollections = [...collections];
    let collectionsList = newCollections.filter(function (e) {
      return e.name !== "";
    });
    setCollections(collectionsList);
    setValue(e.target.value);
  };

  const createCollection = () => {
    let newCollections = [...collections];
    let collectionsList = newCollections.filter(function (e) {
      return e.name === "";
    });
    if (value !== "" && collectionsList.length === 0) {
      let newCollection = [
        {
          id: "",
          name: "",
          createdTime: "",
          buyerId: profileId,
          products: [],
        },
        ...collections,
      ];
      setValue("");
      setCollections(newCollection);
    } else if (collections.length === 0) {
      let newCollection = [
        {
          id: "",
          name: "",
          createdTime: "",
          buyerId: profileId,
          products: [],
        },
        ...collections,
      ];
      setValue("");
      setCollections(newCollection);
    }
  };

  const addNewCollection = (e) => {
    let regex = /^[A-Za-z0-9 ]+$/
    let value = e.target.value;
   
    let name = value.trim();
    if (name.length >= 2 &&  regex.test(value)) {
      setError(false);
      setCharError(false)
      setCollectionName(name);
      setValue(name);
    } else {
      setCollectionName("");
      setValue("");
      if(name.length >= 2){
        setCharError(true)
        setError(false);
      }
      else{
        setError(true);
        setCharError(false)
      }
   
    }
  };

  const saveCollection = () => {
    if(size?.length == 0 && sizes?.length != 0){
      message.error('Please select size');
      setBtnLoading(false);
      return;
    }
    else if(color?.length == 0 && !colors[0] && color === undefined){
      message.error('Please select color');
      setBtnLoading(false);
      return;
    }
    else
    {
    setBtnLoading(true);
    setAnimationLoader(true);
    let newCollection = [...collections];
    let buyerId = profileId.replace("BUYER::", "");
    if (newCollection[0]["name"] === "") {
      newCollection[0]["name"] = collectionName;
    }
    setCollections(newCollection);
    let url = `${process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL}/collections/v1/buyer/product`;
    if(selProductId){
      articleId=selProductId
    }
    fetch(
      url,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
          'trace-id' : uuidv4()
        },
        body:JSON.stringify({
          buyerId : buyerId,
          sellerId : sellerCode,
          articleId : articleId,
          name : value,
          variantId : variantId || "",
          // skuId : skuId || newSkuId || articleId
          skuId : articleId
        })
      }
    )
    .then((res) => {
      if (res.ok) {
        props && props.setSelectedSize && props.setSelectedSize("");
        return res.json();
      } else {
        return res.json().then(data => {
        if (data && data.message === "Product already exists in collection") {
            message.error(data.message);
          } else {
            console.log('Unknown Error:', data);
          }
          throw res;
        });
      }
      })
      .then((res) => {

      //   // Calling add to collcection for log in this event in moengage dashboard
      //   if(props.moengagedata){
      //     // addToCollectionEvent(articleId,props.moengagedata);
      //     add_collection(articleId, props?.moengagedata?.l1Name || "", props?.moengagedata?.productName || "", getConvertedCurrency(props?.displayPrice,props?.currencyDetails)|| 0, props?.currencyDetails.convertToCurrency || "USD");
      //     // add_collection(articleId,prop);
      //   }else {
      //   let productData;
      //   if(contentData){
      //     for(let index=0; index<contentData.length;index++){
      //       if(contentData[index]?.id == `PRODUCT::${articleId}`){
      //         productData=contentData[index];
      //         break;
      //       }
      //     }
      //   }
      //   if(productData){
      //     add_collection(articleId,productData?.l1Name || "", productData?.productName || "", props?.collectionPrice || 0, props?.currentCurrency || "USD");
      //     // addToCollectionEvent(articleId,productData);
      //   }
      // }
        setCollections(res);
        refreshCollection(res);
        onClose();
        savedProductToCollection(value);
        setBtnLoading(false);
        setAnimationLoader(false);
        message.success(`Product with selected properties saved to collection`, 5);
      })
      .catch((err) => {
        logger("error", "Error from saveCollection method AddToCollection: " + url + ": buyerId =>  "+buyerId+ ': error => ' +err?.statusText, process.env.NEXT_PUBLIC_LOGGER_URL);
        console.log(err);
        setBtnLoading(false);
        setAnimationLoader(false);
        if(err.status === 401){
          router.push('/signin');
        }
      });
    }
  };

  const radioStyle1 = {
    height: "40px",
    lineHeight: "40px",
    marginBottom: "30px",
  };
  const radioStyle2 = {
    display: "block",
    height: "50px",
    lineHeight: "50px",
  };

  return (
    <div className="add-to-collection qa-rel-pos">
      <div
        onClick={() => {
          onClose();
          let newCollections = [...collections];
          let collectionsList = newCollections.filter(function (e) {
            return e.name !== "";
          });
          setCollections(collectionsList);
        }}
        style={{
          position: "absolute",
          right: "-8px",
          top: "-8px",
          cursor: "pointer",
          zIndex: "1",
        }}
      >
        <Icon
          component={closeButton}
          style={{ width: "30px", height: "30px" }}
        />
      </div>
      <div className="atc-title qa-mar-btm-1">Save to</div>
      <div className="atc-subtitle qa-pad-btm-1">
        You can now send a Request for quote for an entire collection! Start
        saving products now!
      </div>
      <div className="atc-save-new" onClick={createCollection}>
        <div className="qa-disp-tc">Save new Collection</div>
        <Icon
          component={addToCollectionIcon}
          className="atc-icon"
          style={{
            width: "15px",
            marginLeft: "5px",
            verticalAlign: "middle",
          }}
        />
      </div>
      {collections.length > 0 && (
        <div className="atc-radio-group">
          <Radio.Group onChange={onChange} value={value}>
            {collections.map((collection, i) => {
              return (
                <Radio
                  // style={collection["name"] === "" ? radioStyle1 : radioStyle2}
                  value={collection["name"] === "" ? value : collection["name"]}
                  key={i}
                  disabled={parseInt(collection["productCount"]) === parseInt(collection["productsLimit"])}                   
                >
                  {collection["name"] === "" ? (
                    <div style={radioStyle1}>
                      <Input
                        onChange={addNewCollection}
                        placeholder="Enter name here"
                      />
                      {error && (
                        <div className="qa-error qa-fs-12 qa-mar-top-05">
                          Please enter mimimum 2 characters.
                        </div>
                      )}
                       {charError && (
                        <div className="qa-error qa-fs-12 qa-mar-top-05">
                         Special characters not allowed i.e. ${` !@#$%&*()_<>/`}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div style={{lineHeight:"20px",marginTop:"15px",marginBottom:"-15px",fontFamily:"Sen",fontSize:'13px'}}>
                      <p>{collection["name"]}</p>
                      {
                        parseInt(collection["productCount"]) === 100 ? 
                        <p style={{position : "relative",top:"-15px"}} className="qa-product-count-disabled qa-product-drawer">{collection["productCount"]} of max. {collection["productsLimit"]} products added 
                          <Tooltip title="You can add a maximum of 100 products to a collection. Please create a new collection if you want to add more products">
                            {" "}<InfoCircleOutlined />
                          </Tooltip>
                        </p> : 
                        <p style={{position : "relative",top:"-15px"}} className="qa-product-count qa-product-drawer">{collection["productCount"]} of max. {collection["productsLimit"]} products added 
                        <Tooltip title="You can add a maximum of 100 products to a collection. Please create a new collection if you want to add more products">
                          {" "}<InfoCircleOutlined />
                        </Tooltip>
                        </p>
                      }
                    </div> 
                  )}
                </Radio>
              );
            })}
          </Radio.Group>
        </div>
      )}
      <div>
        <Button
          className="save-collection-button qa-mar-btm-2"
          disabled={!value}
          loading={btnLoading}
          onClick={saveCollection}
        >
          Save
        </Button>
        <Link href="/account/collections" prefetch={false}>
          <Button className="go-to-collection-button">
            Go to my collection
          </Button>
        </Link>
      </div>
      <div className="atc-info">
        You can find your saved collections in My Account/My Collections
      </div>
    </div>
  );
}

export default AddToCollection;
